module.exports = __webpack_public_path__ + "img/68.ae9e9ce1.png";